/* eslint-disable import/prefer-default-export */
import { prop } from "ramda";

export const getPropData = prop("data");
